import { makeAutoObservable } from 'mobx';

import { toastStore } from './ToastStore';

export type ErrorReport = {
	id: number;
	message: string;
	source?: string;
};

class ErrorStore {
	private nextId = 1;
	current?: ErrorReport;

	constructor() {
		makeAutoObservable(this);
	}

	report(error: unknown, source?: string, duration = 7000) {
		if (!error) return;

		const message = this.getMessage(error);
		if (!message) return;

		this.current = {
			id: this.nextId++,
			message,
			source,
		};

		toastStore.show(message, 'error', duration);
	}

	private getMessage(error: unknown) {
		if (error instanceof Error) return error.message;
		if (typeof error === 'string') return error;
		if (error && typeof error === 'object' && 'message' in error) {
			const message = (error as { message?: unknown }).message;
			if (typeof message === 'string') return message;
		}

		return String(error ?? '');
	}
}

export const errorStore = new ErrorStore();